import { Component } from '@angular/core';
import { PlaceholderPageComponent } from '../../../pages/placeholder/placeholder-page.component';

@Component({
  selector: 'app-plane-calculator',
  standalone: true,
  imports: [PlaceholderPageComponent],
  template: `
    <app-placeholder-page 
      title="calculatorList.plane.title" 
      icon="calculator"
      >
    </app-placeholder-page>
  `
})
export class PlaneCalculatorComponent {}